import { Components, Theme } from '@mui/material';

const MuiAvatar: Components<Theme>['MuiAvatar'] = {
  styleOverrides: {
    fallback: ({ theme }) => ({
      color: theme.palette.background.default,
    }),
  },
};

export default MuiAvatar;
